import { LogoMark } from "@/components/brand/logo";

export function RouteLoading() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <LogoMark className="size-9 animate-pulse" />
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    </div>
  );
}
